//import * as common from './types';
import {
  checkMobile,
  checkMobileOperatingSystem,
} from '@common/lib/common/utils';

const state = {
  error: null,
  isMobile: checkMobile ? checkMobile() : '',
  mobileOS: checkMobileOperatingSystem ? checkMobileOperatingSystem() : '',
  appInfo: {
    appVersion: '',
    fbToken: '',
  },
  globalMessage: [],
  notification: {
    list: [],
  },
  loading: false,
  appLoaded: false,

  navigation: {
    drawer: true,
    mini: false,
  },

  // loader
  showLoader: false,
  snackbar: {
    showSnackbar: false,
    snackbarPosX: '',
    snackbarPosY: '',
    snackbarMessage: '',
    snackbarColor: '',
    snackbarDuration: 3000,
    snackbarMultiLine: false,
  },
  //dialog
  dialog: {
    dialogShow: false,
    dialogType: '',
    dialogTitle: '',
    dialogMessage: '',
    dialogHtml: false,
    dialogIcon: null,
    dialogOkCb: () => {},
    dialogCancelCb: () => {},
  },
  showRequiredUpdatePasswordDialog: false,

  customHeaderText: '',
};

export default state;
